var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-tabs', {
    staticClass: "custom-tabs",
    attrs: {
      "background-color": "grey lighten-4",
      "grow": "",
      "show-arrows": "",
      "slider-color": "blue darken-2"
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, _vm._l(_vm.tabs, function (item, index) {
    return _c('v-tab', {
      key: index,
      staticClass: "custom-tab"
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, _vm._l(_vm.tabs, function (item, index) {
    return _c('v-tab-item', {
      key: index
    }, [_c(item.component, {
      key: _vm.tab,
      tag: "component"
    })], 1);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }